<template>
  <b-modal
    ref="modal"
    :cancel-variant="data.cancelVariant || undefined"
    :header-bg-variant="data.headerBgVariant || undefined"
    :footer-bg-variant="data.footerBgVariant || undefined"
    :header-text-variant="data.headerTextVariant || undefined"
    size="lg"
    title-tag="div"
    footer-class="d-none"
    dialog-class="modal-full modal-search-in-header"
    content-class="h-100"
    body-class="h-100"
    :centered="data.centered || false"
    :scrollable="false"
    :no-close-on-backdrop="data.noCloseOnBackdrop || false"
    :no-close-on-esc="data.noCloseOnEsc || false"
    :hide-header-close="data.hideHeaderClose || false"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
  >
    <template v-slot:modal-header-close>
      <b-button
        size="sm"
        variant="primary"
        class="ni ni-close"
        @click="close()"
      >
      </b-button>
    </template>
    <template v-slot:modal-title class="w-100">
      <h5 class="text-white" v-html="data.title"></h5>
      <div class="mt-3">
        <div class="input-group">
          <div
            v-if="hasImg"
            class="input-group-prepend pointer"
            style="cursor: pointer;"
            @click="toggleListImg()"
          >
            <span
              v-if="toggledListImg"
              class="input-group-text ni ni-grid-view"
              :title="_trans('list')"
            ></span>
            <span
              v-else
              class="input-group-text ni ni-list-view"
              :title="_trans('images')"
            ></span>
          </div>
          <input
            v-model="filterElement"
            type="text"
            class="form-control"
          />
          <div class="input-group-append">
            <span class="input-group-text"><i class="ni ni-search"></i></span>
          </div>
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-info"
              style="display: block"
              :class="{ 'active' : !hideObsolete + 'btn-primary' }"
              :title="_trans('view/hide obsolete')"
              @click="hideObsolete=!hideObsolete"
            >
              <i
                v-if="hideObsolete"
                class="ni ni-eye-slash"
              ></i>
              <i
                v-else
                class="ni ni-eye"
              ></i>
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="row">
      <div
        v-if="tree && tree.length > 0"
        class="sidebar col-3"
      >
        <tree
          ref="tree"
          :tree="filteredTree"
          :left-arrow-last="true"
          :hide-branch="hideObsolete ? 'obsoleto' : null"
          :selected-node="rootEl"
          label="des"
          childs="nodes"
          @select="selectTreeItem"
        ></tree>
      </div>
      <div class="content col">
        <!--SEARCH-->
        <!--<div>
          <div class="input-group">
            <div v-if="hasImg" class="input-group-prepend pointer" style="cursor: pointer;" @click="toggleListImg()">
              <span v-if="toggledListImg" class="input-group-text ni ni-grid-view" :title="_trans('list')"></span>
              <span v-else class="input-group-text ni ni-list-view" :title="_trans('images')"></span>
            </div>
            <input type="text" class="form-control" v-model="filterElement"/>
            <div class="input-group-append">
              <span class="input-group-text"><i class="ni ni-search"></i></span>
            </div>
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-info" v-bind:class="{ 'active' : !hideObsolete }" @click="hideObsolete=!hideObsolete" v-bind:title="_trans('view/hide obsolete')">
                <i class="ni ni-plus"></i>
              </button>
            </div>
          </div>
        </div>-->

        <!--IMAGE GRID-->
        <div
          v-if="showImg && filteredElements.length > 0"
          class="my-4 d-flex flex-row flex-wrap justify-content-center"
        >
          <div
            v-for="elem in filteredElements"
            :key="elem.cod"
            class="m-2"
            :class="{ 'var-obsolete': elem.enabletype === 2, 'var-deprecated': elem.enabletype === 1 }"
            :title="elem.des"
            style="max-width: 150px;"
            @click="selectVariant(elem)"
          >
            <label-img
              :img="elem.img"
              :color="elem.imgColor"
              height="150px"
              width="150px"
              :active="currentVariant === elem.cod"
            >
              <div class="text-center mt-2 label">
                <span
                  class="text-truncate"
                  :class="{ 'text-primary': currentVariant === elem.cod }"
                  v-text="elem.des || '-'"
                ></span>
                <span
                  class="text-info text-truncate"
                  v-text="elem.cod"
                ></span>
              </div>
            </label-img>
          </div>
        </div>

        <!--LIST-->
        <div v-else-if="!showImg && filteredElements.length > 0">
          <table class="table table-hover table-borderless">
            <thead>
              <tr>
                <th
                  width="10%"
                  class="border-0"
                  v-text="_trans('Code')"
                ></th>
                <th
                  class="border-0"
                  v-text="_trans('Description')"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="elem in filteredElements"
                :title="elem.des"
                style="cursor: pointer;"
                @click="selectVariant(elem)"
              >
                <td
                  :class="{ 'bg-primary text-white' : currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  v-text="elem.cod"
                ></td>
                <td
                  :class="{ 'bg-primary text-white': currentVariant === elem.cod, 'text-muted obsolete' : elem.enabletype === 2 }"
                  v-text="elem.des"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!--EMPTY CONTENT-->
        <div v-else>
          <h3
            class="text-info text-center p-3 m-0"
            v-text="_trans('No options')"
          ></h3>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import dModalVariant from "@dialogs/modalVariant";

    export default {
        mixins: [dModalVariant]
    };
</script>

<style scoped lang="scss">

  .modal-dialog {
    max-width: 1200px !important;
    margin: 1.75rem auto;
  }
  .modal-content {
    max-height: 100%;

    .modal-header {
      /*display: block;*/
    }

    .modal-body {
      max-height: 100%;
      min-height: 100%;
      overflow: auto;

      .sidebar {

      }

      .content {
        min-height: 100%;
        overflow-y: auto;

        .obsolete {
          text-decoration: line-through;
        }
      }
      .input-group-prepend {
        .input-group-text {
          display: block;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/custom/epoq/dialogs/modalVariant.vue